import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'
import { KToggleButton } from 'components/core/KButton'
import { useOrdering, useCurrentStore } from 'hooks'

interface OrderAsapLaterSelectProps {
  value?: boolean
  onChange?: (value: boolean) => void
}

const TB = styled(KToggleButton)(() => ({
  width: '33.33%',
  fontWeight: 500,
}))

export const OrderAsapLaterSelect = ({
  value,
  onChange,
}: OrderAsapLaterSelectProps) => {
  const { t } = useTranslation()
  const { isAsapEnabled, order } = useOrdering()
  const { isAsapAllowedForOrderType } = useCurrentStore()

  // Check if ASAP is allowed for the current order type
  const isAsapAllowed = isAsapAllowedForOrderType(order?.order_type)

  const orderTypes = [
    {
      value: true,
      label: t('ASAP'),
      // Disable ASAP if:
      // 1. isAsapEnabled is false (based on business hour check)
      // 2. isAsapAllowed is false (based on store being closed)
      disabled: isAsapEnabled === false || !isAsapAllowed,
    },
    {
      value: false,
      label: t('Later'),
      disabled: false,
    },
  ]

  return (
    <Stack sx={{ flexDirection: 'row', gap: 2 }}>
      {orderTypes.map(({ label, value: v, disabled }) => (
        <TB
          key={`${v}`}
          disabled={disabled}
          onClick={() => onChange?.(v)}
          variant={value === v ? 'primary' : 'secondary'}
          size="medium"
        >
          {label}
        </TB>
      ))}
    </Stack>
  )
}
